import light from './light';
import dark from './dark';
import custom from './custom';
import primary from './primary';
import secondary from './secondary';

export default {
  light,
  dark,
  custom,
  primary,
  secondary,
};
